<template>
    <group-details :groupId="props.groupId">
        <group-acuity-list :groupId="props.groupId"></group-acuity-list>
    </group-details>
</template>

<script setup lang="ts">
import GroupDetails from '../GroupDetails.vue';
import GroupAcuityList from './GroupAcuityList.vue';

const props = defineProps({
    groupId: {
        type: String,
        required: true,
    },
});
</script>
